import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/search',
    name: 'search',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/SearchView.vue')
  },
  {
    path: '/comparison',
    name: 'comparison',
    component: () =>
      import(/* webpackChunkName: "comparison" */ '../views/ComparisonView.vue')
  },
  {
    path: '/publications/:id',
    name: 'publication',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/PropertyView.vue')
  },
  {
    path: '/blog',
    name: 'blog',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/BlogView.vue')
  },
  {
    path: '/blog/:id',
    name: 'article',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/ArticleView.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/ContactView.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: () =>
      import(/* webpackChunkName: "login" */ '../views/LoginView.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () =>
      import(/* webpackChunkName: "register" */ '../views/RegisterView.vue')
  },
  {
    path: '/activate-rental-invitation',
    name: 'activate-rental-invitation',
    component: () => import(/* webpackChunkName: "auth-recovery" */ '../views/ActivateRentalInvitationView.vue')
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import(/* webpackChunkName: "auth-recovery" */ '../views/ForgotPasswordView.vue')
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: () => import(/* webpackChunkName: "auth-recovery" */ '../views/ResetPasswordView.vue')
  },
  {
    path: '/account/favorites',
    name: 'favorites',
    component: () =>
      import(/* webpackChunkName: "favorites" */ '../views/accounts/FavoritesView.vue'),
    meta: {
      requiresAuth: true,
      allowedRoles: ['cliente']
    },
  },
  {
    path: '/account/profile',
    name: 'profile',
    component: () =>
      import(/* webpackChunkName: "profile" */ '../views/accounts/ProfileView.vue'),
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/account/alerts',
    name: 'alerts',
    component: () =>
      import(/* webpackChunkName: "alerts" */ '../views/accounts/AlertsView.vue'),
    meta: {
      requiresAuth: true,
      allowedRoles: ['cliente']
    },
  },
  {
    path: '/account/mi-rent',
    name: 'my-rent',
    component: () =>
      import(/* webpackChunkName: "my-rent" */ '../views/accounts/MyRentView.vue'),
    meta: {
      requiresAuth: true,
      allowedRoles: ['cliente']
    },
  },
  {
    path: '/billing',
    name: 'billing',
    component: () =>
      import(/* webpackChunkName: "billing" */ '../views/BillingView.vue'),
    meta: {
      requiresAuth: true,
      allowedRoles: ['admin inmobiliaria', 'super admin', 'agente']
    },
  },
  {
    path: '/subscription-inactive',
    name: 'subscription-inactive',
    component: () =>
      import(/* webpackChunkName: "error" */ '../views/TrialExpiredView.vue'),
  },
  {
    path: '/unauthorized',
    name: 'unauthorized',
    component: () =>
      import(/* webpackChunkName: "error" */ '../views/UnauthorizedView.vue')
  },
  {
    path: '*',
    name: '404',
    component: () =>
      import(/* webpackChunkName: "404" */ '../views/NotFoundView.vue')
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters['auth/isAuthenticated'];
  const userRole = store.getters['auth/getRol'];

  // Chequear si la ruta requiere autenticación
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      next({ name: 'login' });
      return;
    }

    // Chequear si la ruta requiere un rol específico (admin)
    if (to.matched.some(record => record.meta.requiredRole)) {
      const requiredRoles = to.matched.find(record => record.meta.requiredRole)?.meta.requiredRole;
      if (requiredRoles && !requiredRoles.includes(userRole)) {
        next({ name: 'unauthorized' });
        return;
      }
    }

    // Chequear si la ruta define roles permitidos (rutas de cuenta)
    if (to.matched.some(record => record.meta.allowedRoles)) {
      const allowedRoles = to.matched.find(record => record.meta.allowedRoles)?.meta.allowedRoles;
      if (allowedRoles && !allowedRoles.includes((userRole || '').toLowerCase())) {
        next({ name: 'unauthorized' });
        return;
      }
    }

    // Chequear suscripción activa para rutas que la requieran
    if (to.matched.some(record => record.meta.requiresSubscription)) {
      const canAccess = store.getters['billing/canAccessSystem'];
      if (!canAccess) {
        if (store.getters['billing/isTrialExpired']) {
          next({ name: 'billing' });
          return;
        }
        next({ name: 'subscription-inactive' });
        return;
      }
    }

    next();
  } else {
    next();
  }
});

export default router;
